import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import i18n from './lang' // Internationalization
import '@/icons' // icon
import '@/permission' // permission control
import dayjs from 'dayjs'
import './plugins/element.js'

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })

Vue.config.productionTip = false

Vue.filter('toLocalTime', function(value) {
  var newDate = new Date(value)
  var offset = newDate.getTimezoneOffset() / 60
  var hours = newDate.getHours()
  newDate.setHours(hours - offset)
  var localTime = dayjs(newDate).format('YYYY-MM-DD HH:mm:ss')
  return localTime
})

Vue.filter('formatPrice', function(value) {
  return 'NZ$ ' + parseFloat(value / 100).toFixed(2)
})

Vue.prototype.formatPrice = function(value) {
  return 'NZ $' + parseFloat((value * 100) / 10000).toFixed(2)
}

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
